import React from 'react';
import { t } from 'i18next';
import PropTypes from 'prop-types';
import { ModalBody, ModalTitle, ModalButtons } from '../css';
import { contacts } from '../../../utils/constants';

import PrimaryButton from '../../../lib/ui/buttons/PrimaryButton';
import SecondaryButton from '../../../lib/ui/buttons/SecondaryButton';

const CreateQuoteModals = (props) => {
  const {
    embargoErrorMessage,
    isEmbargoErrorMessageUpdated,
    getRatesError,
    Sameday,
    errorType,
    errorMessage,
    isWinterNonServiceableLocation,
    DomesticQuote,
    isManageContactPermission,
    fields,
    USQuote,
    isProtectedAccount,
    isNonServiceableLocation,
    handleModalButtons,
    createQuoteFlag,
  } = props;

  const renderTitle = () => {
    if (isEmbargoErrorMessageUpdated) {
      return errorMessage;
    }

    if (embargoErrorMessage || (getRatesError && !isEmbargoErrorMessageUpdated)) {
      return t('Alert');
    }

    if (Sameday && errorMessage && isWinterNonServiceableLocation) {
      return t('WarningTitle');
    }

    if (DomesticQuote && errorMessage && !isManageContactPermission && fields && fields.tariffError) {
      t(fields.tariffError.value);
    }

    if (USQuote && errorMessage) {
      return t('');
    }

    if (DomesticQuote && errorMessage && isManageContactPermission && fields && fields.ManageContactPermissionTitle) {
      return t(fields.ManageContactPermissionTitle.value);
    }

    if (errorType === 'Invalid Quote Number') {
      return t('Error');
    }

    return t('Wait, you are making a big change!');
  };

  const renderButtons = () => {
    if ((embargoErrorMessage || getRatesError) && !createQuoteFlag) {
      return (
        <div className="col-sm-12 col-md-6">
          <SecondaryButton
            onClick={(e) => handleModalButtons(e)}
            className="active"
            name="returnToStepTwo"
            style={{ padding: '10px' }}
          >
            {t('Okay')}
            <span className="icon" />
          </SecondaryButton>
        </div>
      );
    }

    if ((Sameday && errorMessage && isWinterNonServiceableLocation && !createQuoteFlag)
      || (DomesticQuote && errorMessage && !isManageContactPermission && !errorType && !createQuoteFlag)) {
      return (
        <>
          <div className="col-sm-12 col-md-6 mb-3">
            <PrimaryButton
              onClick={(e) => handleModalButtons(e)}
              className="active"
              name="returnToStepOne"
            >
              {(fields && fields.ReturnToCurrentQuote) ? t(fields.ReturnToCurrentQuote.value) : t('Return')}
              <span className="icon" />
            </PrimaryButton>
          </div>

          <div className="col-sm-12 col-md-6 mb-3">
            <SecondaryButton
              onClick={(e) => handleModalButtons(e)}
              className="active"
              name="createANewQuote"
            >
              {(fields && fields.CreateANewQuote) ? t(fields.CreateANewQuote.value) : t('CreateAQuote')}
              <span className="icon" />
            </SecondaryButton>
          </div>
        </>
      );
    }

    if (DomesticQuote && errorMessage && isManageContactPermission && !createQuoteFlag) {
      return (
        <div className="col-sm-12 col-md-6">
          <SecondaryButton
            onClick={(e) => handleModalButtons(e)}
            className="active"
            name="Okay"
          >
            {t('Okay')}
            <span className="icon" />
          </SecondaryButton>
        </div>
      );
    }

    if (errorMessage || isProtectedAccount || (errorMessage && createQuoteFlag)) {
      return (
        <div className="col-sm-12 col-md-6">
          <SecondaryButton
            onClick={(e) => handleModalButtons(e)}
            className="active"
            name="acceptErrorMessage"
          >
            {t('Accept')}
            <span className="icon" />
          </SecondaryButton>
        </div>
      );
    }

    return (
      <>
        <div className="col-sm-12 col-md-6">
          <SecondaryButton
            onClick={(e) => handleModalButtons(e)}
            className="active"
            name="cancelButton"
          >
            {t('Cancel')}
            <span className="icon" />
          </SecondaryButton>
        </div>
        <div className="col-sm-12 col-md-6">
          <PrimaryButton
            onClick={(e) => handleModalButtons(e)}
            className="active"
            name="continueButton"
          >
            {t('ContinueWithChanges')}
            <span className="icon" />
          </PrimaryButton>
        </div>
      </>
    );
  };

  const renderBody = () => {
    if (isEmbargoErrorMessageUpdated) {
      return (
        <>
          <p>{t('PleaseContactCustomerService')}</p>
          <p>{contacts.LTLCustomerNumber}</p>
          <p>{contacts.CommerceCustomerNumber}</p>
        </>
      );
    }

    if (USQuote && errorMessage && !isEmbargoErrorMessageUpdated) {
      return (
        <>
          <p>{errorMessage}</p>
          {(isNonServiceableLocation || embargoErrorMessage) ? '' : <p>{t('PleaseContactSupportHotline')}</p>}
        </>
      );
    }

    if (DomesticQuote && errorMessage && !isEmbargoErrorMessageUpdated) {
      return (
        <p>{errorMessage}</p>
      );
    }

    if (!isProtectedAccount && !isEmbargoErrorMessageUpdated) {
      return (
        <p>{t('Clicking continue will reset the form')}</p>
      );
    }

    return null;
  };

  return (
    <ModalBody className="justify-content-center">
      {isProtectedAccount ? ''
        : <ModalTitle>{renderTitle()}</ModalTitle>}

      {createQuoteFlag && (errorMessage === t('ErrorMessage')) ? <p><strong>{t('CreateQuoteError')}</strong></p> : renderBody()}
      {(isProtectedAccount) ? <p>{t('ProtectedBillingAccountWarningMsg')}</p> : ''}

      <ModalButtons className="row">{renderButtons()}</ModalButtons>

    </ModalBody>
  );
};

CreateQuoteModals.propTypes = {
  embargoErrorMessage: PropTypes.bool,
  isEmbargoErrorMessageUpdated: PropTypes.bool,
  getRatesError: PropTypes.bool,
  Sameday: PropTypes.bool,
  errorMessage: PropTypes.string,
  isWinterNonServiceableLocation: PropTypes.bool,
  DomesticQuote: PropTypes.bool,
  isManageContactPermission: PropTypes.bool,
  fields: PropTypes.object,
  USQuote: PropTypes.bool,
  isProtectedAccount: PropTypes.bool,
  isNonServiceableLocation: PropTypes.bool,
  handleModalButtons: PropTypes.func,
  errorType: PropTypes.string,
  createQuoteFlag: PropTypes.bool,
};

export default CreateQuoteModals;
